import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-container px-container my-10 md:my-16" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "\n        font-display\n        uppercase\n        text-center text-3xl\n        md:text-4xl\n        lg:text-5xl\n        md:mb-10\n      " }, " ¿Cómo funciona? ", -1)
const _hoisted_3 = { class: "flex flex-col md:flex-row items-center" }
const _hoisted_4 = { class: "w-full md:w-1/2" }
const _hoisted_5 = { class: "md:ml-12 lg:ml-24 space-y-4" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Consigue tu pasaporte AMFF-Filmin durante el festival")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Cines Rívoli (Carrer d’Antoni Marquès 25, Palma) ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Suma los puntos ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Por cada película de la Sección Oficial que veas sumarás un punto en tu pasaporte. ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Recibe regalos")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Canjea tus puntos por regalos exclusivos en el Espacio Filmin de Ses Voltes y/o La Misericòrdia. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImageCard = _resolveComponent("ImageCard")
  const _component_BonoHowItWorksStep = _resolveComponent("BonoHowItWorksStep")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_ImageCard, {
          class: "mb-14 mt-14 md:mb-0 mx-8 md:mx-0",
          rotate: "",
          src: `${_ctx.baseURL}img/bono/pasaporte.png?date=2022-07-06`,
          srcset: 
            [
              `${_ctx.baseURL}img/bono/pasaporte.png?date=2022-07-06 1x`,
              `${_ctx.baseURL}img/bono/pasaporte@2x.png?date=2022-07-06 2x`,
              `${_ctx.baseURL}img/bono/pasaporte@3x.png?date=2022-07-06 3x`,
            ].join(', ')
          
        }, null, 8, ["src", "srcset"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_BonoHowItWorksStep, { index: 1 }, {
          title: _withCtx(() => [
            _hoisted_6
          ]),
          subtitle: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_BonoHowItWorksStep, { index: 2 }, {
          title: _withCtx(() => [
            _hoisted_8
          ]),
          subtitle: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(_component_BonoHowItWorksStep, { index: 3 }, {
          title: _withCtx(() => [
            _hoisted_10
          ]),
          subtitle: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        })
      ])
    ])
  ]))
}